import { Notification } from '@smartgift/frontend-toolkit';
import React, { useMemo, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalValidationErrors } from '@hero/components/molecules';

import { STEP } from '../constant';

import { AddTags } from './AddTags';
import { ADD_TAG_STEP, REVIEW_IMPORT_STEP, UPLOAD_SPREADSHEET_STEP } from './constants';
import { ReviewImport } from './ReviewImport';
import * as S from './style';
import { UploadSpreadSheet } from './UploadSpreadSheet';

const ComponentByStep = {
  [UPLOAD_SPREADSHEET_STEP]: UploadSpreadSheet,
  [ADD_TAG_STEP]: AddTags,
  [REVIEW_IMPORT_STEP]: ReviewImport
};

export function SpreadSheet({ setFooterProps, setModalHeader, setActiveScene, ...props }) {
  const { t } = useTranslation();

  const [uploadedRecipients, setUploadedRecipients] = useState([]);
  const [tags, setTags] = useState([]);
  const [step, setStep] = useState(UPLOAD_SPREADSHEET_STEP);

  const pageLayoutContentRef = useRef(null);

  const steps = useMemo(() => {
    return [
      {
        key: UPLOAD_SPREADSHEET_STEP,
        label: t('uploadSpreadsheet'),
        completed: step === REVIEW_IMPORT_STEP || step === ADD_TAG_STEP,
        stepIndex: 1
      },
      {
        key: ADD_TAG_STEP,
        label: t('addTags'),
        stepIndex: 2
      },
      {
        key: REVIEW_IMPORT_STEP,
        label: t('reviewConfirm'),
        stepIndex: 3
      }
    ];
  }, [step]);

  useEffect(() => {
    setModalHeader({
      title: t('uploadContactSpreadSheet'),
      size: 'xl',
      onBack: () => {
        setActiveScene(STEP.select);
      },
      steps,
      activeStepIndex: 1
    });
  }, []);

  const Component = ComponentByStep[step];

  return (
    <>
      {tags.filter(tag => tag?.automations?.length).length > 0 && (
        <Notification
          style={{ marginBottom: 16 }}
          status="info"
          title={t('blueBadgeAutomation')}
          message={t('blueBadgeAutomationDesc')}
        />
      )}
      <ModalValidationErrors
        pageLayoutContentRef={pageLayoutContentRef}
        style={{ marginBottom: 16 }}
      />
      <S.FormContent>
        <Component
          uploadedRecipients={uploadedRecipients}
          setUploadedRecipients={setUploadedRecipients}
          setActiveScene={setActiveScene}
          setStep={setStep}
          setFooterProps={setFooterProps}
          tags={tags}
          setTags={setTags}
          {...props}
        />
      </S.FormContent>
    </>
  );
}
